import type { Control, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { PCMP_EDIT_LIMITS } from '../../constants/pcmpProposal.constants';
import type { PcmpAccountKind } from '../../types/pcmpProposal.types';
import {
  PCMP_ACCOUNT_FIELDS_BY_KIND,
  PCMP_ACCOUNT_LABELS,
  PCMP_ACCOUNT_REQUIRED_BY_KIND,
} from '../../utils/pcmpAccountForm';

interface PcmpAccountFieldsProps<T extends FieldValues> {
  control: Control<T>;
  kind: PcmpAccountKind;
}

/** The inputs of a bank (holder, bank, branch, A/C, routing) or wallet account. */
export function PcmpAccountFields<T extends FieldValues>({
  control,
  kind,
}: PcmpAccountFieldsProps<T>) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {PCMP_ACCOUNT_FIELDS_BY_KIND[kind].map((name) => (
        <FormField
          key={name}
          control={control}
          // The form's values include every account field (PcmpAccountValues).
          name={name as Path<T>}
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {PCMP_ACCOUNT_LABELS[name]}
                {PCMP_ACCOUNT_REQUIRED_BY_KIND[kind].includes(name) ? (
                  <span className="text-destructive"> *</span>
                ) : null}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  autoComplete="off"
                  inputMode={
                    name === 'routingNo' || name === 'accountNo'
                      ? 'numeric'
                      : name === 'mobileNo'
                        ? 'tel'
                        : undefined
                  }
                  maxLength={
                    name === 'holderName' ? PCMP_EDIT_LIMITS.holderName : PCMP_EDIT_LIMITS.shortText
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  );
}
